import { doc, Timestamp } from 'firebase/firestore';
import { firestore } from '../firebase';
import { Machines, MachineSession } from '../datamodels';
import { createLocalId, machineSessionRepository, workoutRepository } from '../repositories/LocalRepositories';

export const startSession = async (userId: string, setSessionId: (id: string) => void, setSessionActive: (active: boolean) => void, setTimer: (time: number) => void, preferredSessionId?: string): Promise<string | null> => {
  if (!userId) return null;
  try {
    const session = await workoutRepository.create(userId, preferredSessionId);
    setSessionId(session.id); setSessionActive(true); setTimer(0);
    return session.id;
  } catch (error) { console.error('Error starting local session:', error); return null; }
};

export const endSession = async (sessionId: string | null, setSessionActive: (active: boolean) => void, machineSessions: MachineSession[], setMachineSessions: React.Dispatch<React.SetStateAction<MachineSession[]>>) => {
  if (!sessionId) return;
  await workoutRepository.finish(sessionId, machineSessions);
  setSessionActive(false); setMachineSessions([]);
};

export const addMachineSession = async (userId: string, sessionId: string, machine: Machines, exerciseName: string, reps: number, weight: number, machineSessions: MachineSession[], _setMachineSessions: React.Dispatch<React.SetStateAction<MachineSession[]>>, preferredMachineSessionId?: string) => {
  if (!userId || !sessionId) return;
  const existing = machineSessions.find(s => s.machine_ref.id === machine.id && s.exercise_name === exerciseName);
  if (existing) {
    await machineSessionRepository.save({ ...existing, sets: [...existing.sets, { set_number: existing.sets.length + 1, reps, weight }] });
    return;
  }
  const id = preferredMachineSessionId || createLocalId();
  await machineSessionRepository.save({ id, training_session_id: sessionId, machine_ref: doc(firestore, 'machines', machine.id), exercise_name: exerciseName, date_used: Timestamp.now(), sets: [{ set_number: 1, reps, weight }], user_id: userId });
  const workout = await workoutRepository.get(sessionId);
  await workoutRepository.setMachineSessionIds(sessionId, [...(workout?.machine_sessions || []), id]);
};

export const deleteMachineSession = async (uniqueId: string, sessionId: string | null, machineSessions: MachineSession[], setMachineSessions: React.Dispatch<React.SetStateAction<MachineSession[]>>) => {
  if (!uniqueId || !sessionId) return;
  const remaining = machineSessions.filter(machine => machine.id !== uniqueId);
  setMachineSessions(remaining);
  await workoutRepository.setMachineSessionIds(sessionId, remaining.map(machine => machine.id));
  await machineSessionRepository.delete(uniqueId);
};

export const cancelSession = async (sessionId: string, onSuccess: () => void, onError?: (err: any) => void) => {
  try {
    const workout = await workoutRepository.get(sessionId);
    if (!workout) throw new Error('Workout not found');
    await workoutRepository.delete(sessionId, workout.user_id);
    onSuccess();
  } catch (error) { if (onError) onError(error); else console.error('Error canceling session:', error); }
};
